import styled from 'styled-components';

export const SpeakerButtonWrapper = styled.div`
    align-items: center;
    display: flex;
    gap: 6px;
    margin-left: 34px;
`;
